import React from 'react';
import moment from '../../../../moment';
import { getWeekdayDateFormat } from '../../../../utils/date';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CellContext } from '@tanstack/react-table';
import { EnrollmentDataEntry } from './EnrollmentOverview';
import { useTranslation } from 'react-i18next';
import CertificationRiskBadge from '../../../StudentRisk/CertificationRiskBadge';

export const StartDateCell = (cellInfo: CellContext<EnrollmentDataEntry, unknown>) => {
	const { t } = useTranslation();
	const original = cellInfo.row.original;
	const training = original.enrollment.training;
	const showWarning = moment(training.start).isAfter(moment('2021-08-05', 'YYYY-MM-DD'));
	const enrolledToAll =
		training.slots.filter((slot) =>
			slot.students.find((student) => student.id === original.enrollment.student.id),
		).length === training.slots.length;
	const { external } = training;
	return (
		<span style={{ alignItems: 'center', display: 'flex' }}>
			<div className="w-100">
				<span className="glyphicons glyphicons-calendar me-2 font-size-large" />
				{getWeekdayDateFormat(original.startDate)}
			</div>
			{showWarning && !enrolledToAll && !external && (
				<OverlayTrigger
					placement="right"
					overlay={
						<Tooltip id={`tooltip_${training.id}`}>
							{t('enrollments.not_enrolled_to_all_slots_message')}
						</Tooltip>
					}>
					<span className="glyphicons glyphicons-circle-alert text-danger m-1" />
				</OverlayTrigger>
			)}
		</span>
	);
};

export const RiskCell = (cellInfo: CellContext<EnrollmentDataEntry, unknown>) => {
	const { row } = cellInfo;
	return row.original.certificationRisk ? (
		<CertificationRiskBadge risk={row.original.certificationRisk} />
	) : null;
};

export const ExpirationDateCell = (cellInfo: CellContext<EnrollmentDataEntry, unknown>) => (
	<div className="text-secondary">{cellInfo.row.original.enrollment.certificateExpirationDate}</div>
);
